import { PhoneCall, MapPin, FileBadge } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ContactPage({ company }) {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="grid gap-8 lg:grid-cols-2">
        <div className="rounded-sm border border-slate-200 bg-white p-8">
          <h1 data-testid="contact-page-title" className="font-heading text-4xl font-bold text-slate-900">
            Contact HEXA INFOTECH
          </h1>
          <p data-testid="contact-page-subtitle" className="mt-3 text-sm text-slate-600 sm:text-base">
            For immediate quote, call us or send inquiry directly from the product catalog.
          </p>

          <div className="mt-8 space-y-5 text-slate-800">
            <div data-testid="contact-phone-block" className="flex items-start gap-3">
              <PhoneCall className="mt-1 h-5 w-5 text-orange-500" />
              <div>
                <p className="text-xs uppercase tracking-wider text-slate-500">Phone</p>
                <a href={`tel:${company.phone.replace(/\s+/g, "")}`} className="text-lg font-semibold text-slate-900 hover:text-orange-600">
                  {company.phone}
                </a>
              </div>
            </div>

            <div data-testid="contact-address-block" className="flex items-start gap-3">
              <MapPin className="mt-1 h-5 w-5 text-orange-500" />
              <div>
                <p className="text-xs uppercase tracking-wider text-slate-500">Address</p>
                <p className="text-sm leading-6">{company.address}</p>
              </div>
            </div>

            <div data-testid="contact-gst-block" className="flex items-start gap-3">
              <FileBadge className="mt-1 h-5 w-5 text-orange-500" />
              <div>
                <p className="text-xs uppercase tracking-wider text-slate-500">GST</p>
                <p className="text-base font-semibold">{company.gst}</p>
              </div>
            </div>
          </div>

          <Button
            asChild
            data-testid="contact-map-button"
            className="mt-7 rounded-sm bg-slate-900 text-white hover:bg-slate-800"
          >
            <a href={company.mapUrl} target="_blank" rel="noreferrer">
              Open in Google Maps
            </a>
          </Button>
        </div>

        <div className="overflow-hidden rounded-sm border border-slate-200 bg-white">
          <img
            src="https://images.unsplash.com/photo-1573167243872-43c6433b9d40?auto=format&fit=crop&w=1200&q=80"
            alt="Telecom and networking setup"
            data-testid="contact-image"
            className="h-full min-h-[440px] w-full object-cover object-center"
          />
        </div>
      </div>
    </section>
  );
}
